const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    attribute_ids: {
      type: 'array',
      title: 'ویژگی ها',
      items: [],
    },
    attribute_category_ids: {
      type: 'array',
      title: 'دسته بندی ها',
      items: [],
    },
  },
});

export default schema;
